module.exports = __webpack_public_path__ + "img/235.bc23cb68.png";